export const generateRangeArray = (start = 0, end = 100, step = 1) => {
  let range = [];
  for (let i = start; i <= end; i += step) {
    range.push(i.toString());
  }
  return range;
};
